import React from 'react';
import _ from 'underscore';

import {ExtensionsSettingsCoordinator} from '~src/settings/general-settings/components/extensions-settings/ExtensionsSettingsCoordinator';
import {subspaceStyle} from '~src/settings/styles/CommonStyles';

import {SessionManagementService} from '../../../sessionManagement/SessionManagementService';
import {FeatureFlags} from '../../../ts/FeatureFlags';
import {RouterError} from '../RouterHelpers/RouterError';
import { ExtensionsSettingsSubspaceState, getData } from '../SharedSettingsSpace/ExtensionsSettingsSubspaceShared';
import {SpacesSiteUrls} from '../SpacesSiteUrls';

interface ExtensionsSiteSettingsSubspaceOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
  readonly isSessionServerAdmin: boolean;
}

export class ExtensionsSiteSettingsSubspaceComponent extends React.PureComponent<ExtensionsSiteSettingsSubspaceOwnProps, ExtensionsSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: ExtensionsSettingsSubspaceState = {
    isServerPage: false,
    isMultiSite: undefined,
    hasDataToRender: false,
    hasError: false,
    dashExtServerSettings: undefined,
    dashExtSiteSettings: undefined,
    extsvcServerSettings: undefined,
    analyticsExtensionsServerSettings: undefined,
    analyticsExtensionsSiteSettings: undefined,
    siteSettingsForSiteAdmin: undefined,
  };

  public constructor(props: ExtensionsSiteSettingsSubspaceOwnProps) {
    super(props);
    this.state = {
      ...this.initialState,
      isMultiSite: props.isSessionMultiSite
    };
  }

  public componentDidMount() {
    getData(
      (newState) => { this.updateState(newState as ExtensionsSettingsSubspaceState); },
      () => { this.updateState({hasError: true}); }
    );
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate(prevProps: ExtensionsSiteSettingsSubspaceOwnProps) {
    if (!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.updateState(this.initialState);
      getData(
        (newState) => { this.updateState(newState as ExtensionsSettingsSubspaceState); },
        () => { this.updateState({hasError: true}); }
      );
      return;
    }

    if (!_.isUndefined(this.state.dashExtServerSettings)
      && !_.isUndefined(this.state.dashExtSiteSettings)
      && (!_.isUndefined(this.state.siteSettingsForSiteAdmin) || !FeatureFlags.prepExtensionsEinstein)
      && (!_.isUndefined(this.state.analyticsExtensionsSiteSettings))
      && (!_.isUndefined(this.state.analyticsExtensionsServerSettings))
    ) {
      this.updateState<'hasDataToRender'>({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      if (this.props.urls instanceof SpacesSiteUrls) {
        return <RouterError errorType={'default'} urls={this.props.urls}/>;
      } else {
        return <RouterError errorType={'server-default'} urls={this.props.urls}/>;
      }
    }

    return (
      <div className={subspaceStyle}>
        <ExtensionsSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof ExtensionsSettingsSubspaceState>(newState: Pick<ExtensionsSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }
}
